export const transactionType = {
    "סוג_תנועה": "תאור סוג תנועה",
    "נצר": "נצר",
    "פ": "פשוטה",
    "פ-BI": "פקודות BI",
    "מ": "תנועה מורכבת",
    "קיור": "חשבונית ספק קיור",
    "חל": "חשבונית מס",
    "חק": "חש. מס - קבלה",
    "ק": "קבלה",
    "חלמ": "חשבונית לקוח מרכזת",
    "חלמאע": "חלמ איחוד עוסקים",
    "חלז": "חשבונית זיכוי",
    "חלזאע": "ח.זיכוי א.עוסקים",
    "חי": "חשבונית לחו'ל",
    "חיז": "חש. זיכוי לחו'ל",
    "חס": "חשבונית ספק",
    "עסק": "חשבונית עסקה",
    "חלק1": "עמק חפר עובדים",
    "חלק2": "שטחים אחזקה",
    "חלק3": "ציוד מתכלה",
    "חלק4": "פרויקט ERP",
    "חלק5": "נקטו",
    "חלק6": "סיסטמס",
    "חלק7": "סינריון",
    "חלק8": "שילוח 6(חשמל)",
    "חסמ": "חש. ספק מרכזת",
    "חסמאע": "חסמ איחוד עוסקים",
    "חסר": "חש. ספק מרכזת",
    "חסז": "חש. זיכוי מהספק",
    "חסזאע": "חסז איחוד עוסקים",
    "חחס": "חש. חיוב לספק",
    "העב": "העברה בנקאית",
    "מעח": "מע'מ חריג 2/3",
    "תשצ": "תשלום בהמחאה",
    "הח": "המחאות חוזרות",
    "ז2/3": "זיכוי 2/3 מע'מ",
    "החל": "תשלום חוזר ללקוח",
    "הפב": "הפקדה",
    "חזס": "חש. זיכוי לספק",
    "הפק": "הפקדה לקופה",
    "יפ": "יתרת פתיחה",
    "EXP": "cExpence",
    "הש": "הפרשי שער",
    "תשאש": "תשלום בכרטיס אש.",
    "מטח": "תיקון מט'ח",
    "שקל": "תיקון שקלים",
    "בטה": "ביטול הפקדה",
    "בטל": "ביטול תשלום",
    "החת": "החזרת תשלום",
    "הת": "תנועת התאמה",
    "פחת": "פחת רכוש קבוע",
    "גרע": "גריעת רכוש קבוע",
    "הלו": "פרעון הלוואות",
    "עמ": "עלות המכירות",
    "פד": "המחאות דחויות",
    "ליס": "תשלום ליסינג",
    "תשד": "תשלומים דחויים",
    "לסז": "זיכוי ליסינג",
    "תמ": "תנועת מלאי",
    "שוי": "הערכת שווי רכוש",
    "שע": "שעות עבודה יצור",
    "עק": "עלות יצור עקיפה",
    "ספמ": "ספירת מלאי",
    "השמ": "השמדת מלאי",
    "תמש": "משלוח ללקוח",
    "דגמ": "לקיחת דגימות",
    "נשש": "ניפוק שוטף",
    "הרכ": "הרכבות",
    "המר": "המרות מלאי",
    "תקן": "שינוי מחיר תקן",
    "רל": "ריבית לקוחות",
    "עי": "עלויות יבוא",
    "הזל": "הזמנה",
    "הזר": "הזמנת רכש",
    "משל": "משלוח סחורה",
    "קבמ": "קבלה למלאי",
    "חסי": "חשבונית ספק בארץ",
    "ס23": "חש' ספק 2/3מע17%",
    "ס18": "חשבוניית ספק 18%",
    "ר18": "ש'ספק2/3 מעמ18%",
    "3/4": "חש'ספק3/4 מעמ18%",
    "אשר": "התאמת כר. אשראי",
    "דרש": "דרישות רכש",
    "שכר": "שכר עבודה",
    "שכר31": "שכר עבודה GEN",
    "שכ2": "תשלום שכר",
    "שכ3": "תשלום לקרנות",
    "חעס": "חש. עסקה מספק",
    "זאש": "זיכוי אשראי",
    "נפק": "ניפוקים",
    "חי0": "חשבונית לקשורות",
    "חא0": "חשבונית מעמ 0",
    "חקש": "חשבונית-חברות קש",
    "163": "חש'ספק3/4מע16.5%",
    "פרש5": "פרישת הוצאות 5",
    "173": "חש'ספק3/4 מעמ17%",
    "פרש6": "פרישת הוצאות 6",
    "פרש7": "פרישת הוצאות 7",
    "155": "חש ספק מעמ 15.5%",
    "פרש9": "פרישת הוצאות 9",
    "165": "חש ספק מעמ 16.5%",
    "פרש10": "פרישת הוצאות 10",
    "חס0": "חש ספק מעמ 0",
    "פרש11": "פרישת הוצאות 11",
    "חסק": "חש ספק-חב קשורות",
    "פרש12": "פרישת הוצאות 12",
    "חלק": "חש לקוח-חב קש",
    "פרש3": "פרישת הוצאות 3",
    "2/3": "מע'מ 2/3",
    "חעצ20": "חשבונית עצמית",
    "חעצ21": "חשבונית עצמית",
    "חעצ31": "חשבונית עצמית",
    "חעצ41": "חשבונית עצמית",
    "חעצ51": "חשבונית עצמית אל",
    "חעצ22": "חשבונית עצמית",
    "חעצ23": "חשבונית עצמית",
    "Other": "נסיעה לחול- אחר",
    "גריעה": "גריעת רכוש קבוע",
    "אמז": "חש. לקוח - אמזון",
    "RentC": "נסיעה לחול-רכב",
    "PerDI": "נסיעה לחול- אשל",
    "Fligh": "נסיעה לחול- טיסה",
    "Hotel": "נסיעה לחול- מלון",
    "פ-תשצ": "ידני-תשלום המחאה",
    "פח1": "הפקדה לפחק",
    "פח2": "משיכה מפח\"ק",
    "פח3": "הפקדה לפח\"ק לאומ",
    "פח4": "משיכה מפח\"ק לאומ",
    "רצנ": "נצר",
    "תש1": "תשלום עמלות יבוא"
  }
  